import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "name",
    headerName: "Name",
    width: 150,
  },
  {
    field: "email",
    headerName: "Email",
    width: 150,
  },
  {
    field: "createdAt",
    headerName: "Joined at",
    type: "number",
    width: 110,
  },
];

export default function Table({ data }) {
  return (
    <div className="table-container">
      <DataGrid
        getRowId={(row) => row.id}
        autoHeight
        rows={data}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 15, 20, 25, 30]}
      />
    </div>
  );
}
